module.exports = __webpack_public_path__ + "img/gq.3a66a4a1.svg";